<template>
    <div class="input-wrap" :class="contList" >
        <input type="checkbox" :id="checkLabel" :name="checkName" :value="inputValue" v-model="model">
        <label :for="checkLabel" v-html="checkText" ></label>
    </div>
</template>

<script>
export default {
  name: 'UiCheck',
  props: {
    errorText: {
      type: String,
      default: ''
    },
    checkText: {
      type: String,
      default: ''
    },
    checkLabel: {
      type: String,
      default: ''
    },
    checkName: {
      type: String,
      default: ''
    },
    contList: {
      type: String,
      default: ''
    },
    value: {},
    inputValue: { },
    index: {},
    parentIndex: {}
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value, this.index, this.parentIndex, 'checkbox')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.input-wrap {
    margin-top: 25px;
    padding-left: 30px;
    label {
        display: inline-block;
        padding: 0 0 0 30px;
        background: url('../../assets/images/icon-check.svg') no-repeat left top 1px;
        font-size: 14px;
        line-height: 1.57;
        color: #444;
        cursor: pointer;
    }
    input[type=checkbox] {
        display: none;

        &:checked + label {
            background: url('../../assets/images/icon-check-on.svg') no-repeat left top 1px;
        }
    }
    &.information {
        display: inline-block;
        label {
          padding: 0 0 0 25px;
        }
    }
}
@media all and (max-width: 768px) {
    .input-wrap {
        padding-left: 0px;
        &.information {
            margin-top: 20px;
        }
    }
}

</style>
